function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

import * as React from 'react';

function SearchIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M485.2 463.2L386 364c68.8-80 65.6-201.6-11.2-278.4-40-40-92.8-59.2-144-59.2-52.8 0-104 19.2-144 59.2-80 80-80 209.6 0 289.6 40 40 92.8 59.2 144 59.2 46.4 0 94.4-16 132.8-48l99.2 99.2 22.4-22.4zm-376-110.4c-67.2-67.2-67.2-176 0-243.2 32-33.6 75.2-51.2 121.6-51.2s89.6 17.6 121.6 51.2c67.2 67.2 67.2 176 0 243.2-32 32-75.2 51.2-121.6 51.2s-89.6-17.6-121.6-51.2z"
  }));
}

export default SearchIcon;